import { UserProfile } from 'fitbeat.gym-core';
import { createSelector } from 'reselect';
import { PaywallScreen } from '../../auth';
import { hasAccessToAStudioGymSelector } from '../../auth/auth-selectors';
import { IAppStore } from '../../HomeWorkouts';
import { GymResolver } from '../../services';

export const haveCouponPressedSelector = createSelector(
  [(state: IAppStore) => state.payments.haveCouponPressed],
  (haveCouponPressed) => haveCouponPressed,
);

export const verifyingCouponInProgressSelector = createSelector(
  [(state: IAppStore) => state.payments.verifyingCouponInProgress],
  (verifyingCouponInProgress) => verifyingCouponInProgress,
);

export const couponVerificationFailedSelector = createSelector(
  [(state: IAppStore) => state.payments.couponVerificationFailed],
  (couponVerificationFailed) => couponVerificationFailed,
);

export const couponToApplySelector = createSelector(
  [(state: IAppStore) => state.payments.couponToApply],
  (couponToApply) => couponToApply,
);

export const getPaymentSubscriptionSummarySelector = createSelector(
  [(state: IAppStore) => state.payments.paymentSubscriptionSummary],
  (paymentSubscriptionSummary) => paymentSubscriptionSummary,
);

export const getRemoveCouponInProgressSelector = createSelector(
  [(state: IAppStore) => state.payments.removeCouponInProgress],
  (removeCouponInProgress) => removeCouponInProgress,
);

export const getPaywallScreenSelector = createSelector(
  [
    (state: IAppStore) => state.deepLinkParamaters.planId,
    (_, userProfile: UserProfile) => userProfile,
    hasAccessToAStudioGymSelector,
  ],
  (planId, userProfile: UserProfile, hasAccessToAStudioGym) => {
    const gym = GymResolver.getByName(userProfile.gymName);
    const shouldSelectPlanOnExternalPage = !gym.shouldUseInAppPurchaseForMembership;
    if (hasAccessToAStudioGym || shouldSelectPlanOnExternalPage) {
      if (planId) {
        return PaywallScreen.CardPayment;
      }
      return PaywallScreen.SelectStudioPlan;
    }
    if (UserProfile.signedUpThroughInfluencerLink(userProfile)) {
      return PaywallScreen.CardPayment;
    }
    return PaywallScreen.InAppPurchase;
  },
);
